import './index.scss';

import React from 'react';

class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open || false,
    };
    this.timerId = null;
  }

  componentDidMount() {
    if (this.props.open) {
      this.startTimer();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      if (this.props.open) {
        this.setState({ open: true }, this.startTimer);
      } else {
        this.setState({ open: false });
        this.clearTimer();
      }
    }
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  startTimer = () => {
    this.clearTimer();

    this.timerId = setTimeout(() => {
      this.setState({ open: false }, () => {
        this.props.onClose?.();
      });
    }, this.props.timer || 5000);
  };

  clearTimer = () => {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  };

  handleManualClose = () => {
    this.clearTimer();
    this.setState({ open: false }, () => {
      this.props.onClose?.();
    });
  };

  render() {
    const { classes = {}, children } = this.props;
    const toastrContentClasses = classes.options || '';

    if (!this.state.open) {
      return null;
    }

    return (
      <div className={`toastrContent toast ${toastrContentClasses}`}>
        {children}
        <a onClick={this.handleManualClose}>
          <i className="material-icons closeIcon">close</i>
        </a>
      </div>
    );
  }
}

export default Toast;
